// extracted by mini-css-extract-plugin
export default {"openButton":"kC-z","modalContent":"lC-z","hideOutsideOfMobile":"mC-z"};